export default "__VITE_ASSET__0692858d__"